import { render } from "./Tooltip.vue?vue&type=template&id=c7a6c484&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=c7a6c484&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c7a6c484"

export default script